<section class="container-fluid mt-5">

    <div class="row">
        <div class="col-12">
            <h2>Todos los eventos</h2>
    
            <div class="container-fluid">
                <table class="table mt-3">

                    <thead>
                        <tr>
                            <th>PULLEP</th>
                            <th>Nombre</th>
                            <th>Lector</th>
                          

                        </tr>



                    </thead>
                    <tbody>

                        <tr *ngFor="let evento of eventos">
                            <td>{{evento?.id}}</td>
                            <td>{{evento?.nombre }}</td>
                            <td><button class="btn btn-success" routerLink="lector/{{evento.id}}"> Lector</button></td>
                        </tr>


                    </tbody>

                </table>
            </div>

        </div>
    </div>
</section>